import React from 'react';
import { Button } from 'antd';
import Column from 'antd/lib/table/Column';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { QueryKey } from 'api/queryKey';
import { useEnsureContext } from 'common/hooks';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { Header } from 'common/components/Header';
import { NumberedTable } from 'common/components/NumberedTable';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useRole } from 'common/hooks/useRole';
import { commonPaginationConfig, initialPageParams } from 'models/page';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { AssignAdditionalDevicesToPartnerModal } from 'pages/BusinessPartnerManagement/BusinessPartnerAdditionalDevicesManagement/AssignAdditionalDevicesToPartnerModal';

const mapDeviceTypeToLabel = (deviceType?: string | null) => {
  if (deviceType === 'OXIMETER') {
    return 'OXY';
  }

  if (deviceType === 'BP_MONITOR') {
    return 'BPM';
  }

  return deviceType !== null && deviceType !== undefined && deviceType !== ''
    ? deviceType
    : '--';
};

export const BusinessPartnerAdditionalDevicesPage = () => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const [pageMetaData, setPageMetaData] = useState(initialPageParams);
  const [isAssignModalVisible, setIsAssignModalVisible] = useState(false);
  const intlMessage = useFormatMessage();
  const { isSuperAdmin } = useRole();

  const { data, isFetching, refetch } = useQuery(
    [QueryKey.BusinessPartnerAdditionalDevicesList, bpContext.id, pageMetaData],
    () =>
      BusinessPartnersAPI.fetchAdditionalDevicesForLocaAdmin(bpContext.id, {
        ...pageMetaData,
      }),
    {
      keepPreviousData: true,
    }
  );

  const paginationConfig = {
    ...commonPaginationConfig,
    current: pageMetaData?.page,
    pageSize: data?.size,
    total: data?.totalElements,
    onChange: (page: number, pageSize?: number) =>
      setPageMetaData((prev) => ({
        ...prev,
        page,
        ...(pageSize && { pageSize }),
      })),
  };

  return (
    <div>
      <Header
        title={intlMessage({ id: 'additionalDevices' })}
        extra={[
          isSuperAdmin ? (
            <Button
              id="button-assign-new-additional-device"
              key="assign-new"
              type="primary"
              onClick={() => setIsAssignModalVisible(true)}
            >
              {intlMessage({ id: 'devices.assignNew' })}
            </Button>
          ) : null,
        ]}
      />
      <AssignAdditionalDevicesToPartnerModal
        visible={isAssignModalVisible}
        businessPartnerId={bpContext.id}
        onCancel={() => setIsAssignModalVisible(false)}
        onAssigned={() => {
          refetch();
        }}
      />
      <NumberedTable
        rowKey="id"
        loading={isFetching}
        dataSource={data?.content}
        pagination={paginationConfig}
        scroll={{ x: 'auto' }}
      >
        <Column
          title={intlMessage({ id: 'deviceSerialNumber' })}
          dataIndex="serialNumber"
          render={(value) => (value !== null && value !== '' ? value : '--')}
        />
        <Column
          title={intlMessage({ id: 'deviceType' })}
          dataIndex="deviceType"
          render={(value) => mapDeviceTypeToLabel(value)}
        />
        <Column
          title={intlMessage({ id: 'partner' })}
          dataIndex="partnerName"
          render={(value) => (value !== null && value !== '' ? value : '--')}
        />
        <Column
          key="actions"
          title={intlMessage({ id: 'actions' })}
          align="right"
          render={() => null}
        />
      </NumberedTable>
    </div>
  );
};
